<template>
  <div>
    <template>
      <h4 class="not-margin" :style="{ fontWeight: 'bold', color: '#195BFF', fontSize: '18px', textAlign: 'left' }">
        <i class="fal fa-info-circle" :style="{ width: '25px', fontSize: '18px' }"></i>
        ເພີ່ມສາຂາທີ່ຈັດສົ່ງ
      </h4>
    </template>

    <div class="field" :style="{marginTop: '20px'}">
      <div class="control">
        <label class="label">
          ສາຂາທີ່ຈັດສົ່ງ
          <span class="text-danger">* {{ errors.first('branch_delivery_ids') }}</span>
          <span class="text-danger">
                        {{ server_errors.branch_delivery_ids }}
                    </span>
        </label>
        <div :style="{marginTop: '5px'}">
          <vs-select
              filter multiple
              placeholder="ກະລຸນາເລືອກສາຂາທີ່ຈັດສົ່ງ..."
              name="branch_delivery_ids"
              v-model="branch_delivery_ids"
              v-validate="'required'">
            <vs-option
                v-for="(item, index) in branches"
                :label="item.name"
                :value="item.id"
                :key="index">
              {{ item.name }}
            </vs-option>
          </vs-select>
        </div>
      </div>
    </div>

    <div ref="target" id="target" class="center">
      <div class="con-btns">
        <vs-button ref="button" flat @click="validateForm()" class="form-btn-loading" :loading="btnLoading">ບັນທຶກ
        </vs-button>
      </div>
    </div>

  </div>
</template>

<script>

const validateMessage = {
  custom: {
    branch_delivery_ids: {
      required: 'ກະລຸນາເລືອກສາຂາທີ່ຈັດສົ່ງ.',
    },
  }
};

export default {
  props: ['branch_delivery_id', 'branches'],

  data: () => ({
    server_errors: {
      branch_delivery_ids: '',
    },
    branch_delivery_ids: [],
    btnLoading: false,
  }),
  methods: {
    validateForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.saveItem();
        }
      });
    },
    saveItem() {
      this.btnLoading = true;
      this.$axios.post('branch-delivery-link/' + this.branch_delivery_id, {
        ids: this.branch_delivery_ids,
      }).then(() => {
        this.$emit('close');
        this.$emit('success');
      }).catch(() => {
      }).finally(() => {
        this.btnLoading = false;
      });
    }
  },
  watch: {
    branch_delivery_id: function () {
      this.server_errors.branch_delivery_ids = '';
    },
  }, created() {
    this.$validator.localize('en', validateMessage);
  }
}
</script>
